import { Component } from '@angular/core';

@Component({
  selector: 'app-gamification-widget',
  templateUrl: './gamification-widget.component.html',
  styleUrls: ['./gamification-widget.component.css']
})
export class GamificationWidgetComponent {}
